import { FingerprintProvider } from "@fingerprint/react";
import React from "react";
import ReactDOM from "react-dom/client";

import {
  FINGERPRINT_API_KEY,
  FINGERPRINT_ENDPOINTS,
  FINGERPRINT_REGION,
} from "constants/env";

import "./index.scss";
import Root from "./Root";

// Bump this on each release. Logged to the browser console on load so we can
// confirm which version is deployed.
const APP_VERSION = "1.0.0";
console.log(`Slapshot frontend version: ${APP_VERSION}`);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <FingerprintProvider
    apiKey={FINGERPRINT_API_KEY}
    region={FINGERPRINT_REGION}
    endpoints={FINGERPRINT_ENDPOINTS}
  >
    <Root />
  </FingerprintProvider>,
);
